import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { policyDetail, exportZip } from './request';
import topTitle from '@/components/title';
import previewListModal from './../../claim/demageManage/previewListModal.vue';
import { downloadFileFun } from '@/utils/public';
export default {
  components: {
    topTitle,
    previewListModal
  },
  data() {
    return {
      dataFrom: {},
      dataFrom2: {
        insuranceList: []
      },
      columns: [{
        slots: {
          title: '产品名称'
        },
        dataIndex: 'insuranceName',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '产品类型'
        },
        dataIndex: 'type',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'type'
        }
      }, {
        slots: {
          title: '方案名称'
        },
        dataIndex: 'planName',
        key: 'planName',
        align: 'center'
      },
      // {title: '方案代码', dataIndex: 'planCode', key: '2', align: 'center'},
      {
        slots: {
          title: '保障额度'
        },
        dataIndex: 'amount',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '保费'
        },
        dataIndex: 'price',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '区域'
        },
        dataIndex: 'area',
        key: 'area',
        align: 'center'
      }, {
        slots: {
          title: '折扣保费'
        },
        dataIndex: 'discountPrice',
        key: 'discountPrice',
        align: 'center'
      }],
      data: [],
      policyInfoList: [{
        name: '保单号',
        key: 'policyNo'
      }, {
        name: '产品名称',
        key: 'insuranceName'
      }, {
        name: '产品标识',
        key: 'insuranceMark'
      }, {
        name: '产品代码',
        key: 'insuranceCode'
      }, {
        name: '产品大类',
        key: 'insuranceSorName'
      }, {
        name: '等待期',
        key: 'waitTime'
      }, {
        name: '险种分类',
        key: 'insuranceClassificationName'
      }, {
        name: '承保单位',
        key: 'unitName'
      }, {
        name: '中介机构',
        key: 'intermediaryName'
      }, {
        name: '机构全称',
        key: 'agencyName'
      }, {
        name: '生效日期',
        key: 'startAt'
      }, {
        name: '终止日期',
        key: 'endAt'
      }, {
        name: '出单模式',
        key: 'isTimely'
      }, {
        name: '保单状态',
        key: 'policyStatus'
      }, {
        name: '失败原因',
        key: 'cancelMessage'
      }],
      baseInfo: [{
        name: '订单号',
        key: 'orderNo'
      }, {
        name: '用户名',
        key: 'userName'
      }, {
        name: '牌照所属',
        key: 'licenseCustomerName'
      }, {
        name: '手机号',
        key: 'mobile'
      }, {
        name: '保单来源',
        key: 'applicationName'
      }, {
        name: '投保时间',
        key: 'createAt'
      }, {
        name: '用户级别',
        key: 'userLevel'
      }, {
        name: '支付方式',
        key: 'payType'
      }, {
        name: '投保份数',
        key: 'servings'
      }, {
        name: '保单归属',
        key: 'customerName'
      }, {
        name: '费率类型',
        key: 'rate'
      }],
      cancelInsuredInfo: [],
      previewVisible: false,
      previewImg: '',
      previewImgVisible: false,
      fileList: []
    };
  },
  created() {
    policyDetail({
      policyId: this.$route.params.id
    }).then(res => {
      var _this$dataFrom;
      this.dataFrom = res.baseInfo;
      this.dataFrom2 = res.policyInfo;
      if (!((_this$dataFrom = this.dataFrom2) !== null && _this$dataFrom !== void 0 && (_this$dataFrom = _this$dataFrom.insuranceList) !== null && _this$dataFrom !== void 0 && (_this$dataFrom = _this$dataFrom[0]) !== null && _this$dataFrom !== void 0 && _this$dataFrom.discountPremium)) {
        //没有折扣信息的时候不显示折扣保费
        this.columns = this.columns.filter(item => item.dataIndex !== 'discountPrice');
      } else {
        this.dataFrom2.insuranceList = this.dataFrom2.insuranceList.map(item => {
          if (item.discountPremium && Object.keys(item.discountPremium).length) {
            item.discountPrice = this.computedDiscountPrice(item.price, item.discountPremium);
          } else {
            item.discountPrice = '-';
          }
          return item;
        });
      }
      this.data = res.insuredInfo;
      this.cancelInsuredInfo = res.cancelInsuredInfo;
    });
  },
  methods: {
    previewFun() {
      if (this.dataFrom2.policyUrl.length == 1 && this.dataFrom2.policyUrl[0].format == 'pdf') {
        window.open(this.dataFrom2.policyUrl[0].url);
      } else {
        this.fileList = this.dataFrom2.policyUrl.map((i, index) => {
          i.status = 'done';
          i.uid = index + 1;
          return i;
        });
        this.previewVisible = true;
      }
    },
    isImg(value) {
      if (value && typeof value === 'string' && value.includes('oss-cn-beijing.aliyuncs.com')) {
        return true;
      }
      return false;
    },
    isImgArr(value) {
      if (value && Array.isArray(value) && value.length && value[0].includes('oss-cn-beijing.aliyuncs.com')) {
        return true;
      }
      return false;
    },
    imgView(value) {
      this.previewImgVisible = true;
      this.previewImg = value;
    },
    async downloadImgFun(name) {
      const res = await exportZip({
        policyId: this.$route.params.id
      });
      downloadFileFun(res, 'application/zip', name);
    },
    computedDiscountPrice(value, discountRule) {
      let result = '-';
      if (!value) {
        return result;
      }
      if (discountRule) {
        const num = discountRule.discountMode === 'ratio' ? discountRule.discountRatio : discountRule.discountAmount;
        if (num <= 0) {
          this.$message.error(this.$t('必须输入大于0的数字'));
          return result;
        }
        if (discountRule.discountMode == 'ratio' && num >= 100) {
          this.$message.error(this.$t('折扣比例必须小于100的数字'));
          return result;
        }
        if (discountRule.discountMode === 'ratio') {
          result = Number(Number(value) * 100 - Number(value) * 100 * Number(discountRule.discountRatio / 100)) / 100;
        }
        if (discountRule.discountMode === 'amount') {
          result = Number(Number(value) * 100 - Number(discountRule.discountAmount) * 100) / 100;
        }
        result = result > 0 ? parseFloat(result).toFixed(2) : 0;
        return result;
      }
    }
  }
};